import Currency from '../../components/currency/Currency';

type JournalTotalsProps = {
    values: {
        debitTotal: number;
        creditTotal: number;
        debitSubtotal?: number;
        creditSubtotal?: number;
        debitTaxTotal?: number;
        creditTaxTotal?: number;
        valueOutBy?: number;
    };
    showTaxRate: boolean;
};

function JournalTotals({ values, showTaxRate }: JournalTotalsProps): JSX.Element {
    return (
        <>
            <div className="grid grid-cols-[25px_90%_5%] gap-4">
                <div className={`flex flex-col ${showTaxRate ? 'lg:flex-row' : 'md:flex-row'} w-full col-start-2 ml-4`}>
                    <div className={`grid gap-2 ${showTaxRate ? 'lg:gap-4' : 'md:gap-4'} w-full items-center grid-cols-[1.3fr_1.5fr]`} />
                    <div className={`grid gap-2 w-full pt-4 items-center ${showTaxRate ? 'grid-cols-3 lg:gap-4' : 'grid-cols-2 md:gap-4'}`}>
                        <div className={`flex flex-col items-end ${showTaxRate ? 'col-start-2' : 'col-start-1'} pr-3`}>
                            <div className="font-bold text-gray-500 text-sm">Debits Total</div>
                            <Currency value={values.debitTotal} convertToHighestDenomination={false} className="text-gray-800 text-base" />
                        </div>
                        <div className={`flex flex-col items-end ${showTaxRate ? 'col-start-3' : 'col-start-2'} pr-4`}>
                            <div className="font-bold text-sm text-gray-500">Credits Total</div>
                            <Currency value={values.creditTotal} convertToHighestDenomination={false} className="text-gray-800 text-base" />
                        </div>
                    </div>
                </div>
            </div>
            {showTaxRate && values.debitSubtotal !== undefined && values.creditSubtotal !== undefined && (
                <div className="grid grid-cols-[25px_90%_5%] gap-4">
                    <div className={`flex flex-col ${showTaxRate ? 'lg:flex-row' : 'md:flex-row'} w-full col-start-2 ml-4`}>
                        <div
                            className={`grid gap-2 ${showTaxRate ? 'lg:gap-4' : 'md:gap-4'} w-full items-center grid-cols-[1.3fr_1.5fr]`}
                        />
                        <div
                            className={`grid gap-2 w-full pt-1 items-center ${
                                showTaxRate ? 'grid-cols-3 lg:gap-4' : 'grid-cols-2 md:gap-4'
                            }`}
                        >
                            <div className={`flex flex-col items-end ${showTaxRate ? 'col-start-2' : 'col-start-1'} pr-3`}>
                                <div className="font-bold text-xs text-gray-600">Subtotal</div>
                                <Currency
                                    value={values.debitSubtotal}
                                    convertToHighestDenomination={false}
                                    className="text-sm text-gray-600"
                                />
                            </div>
                            <div className={`flex flex-col items-end ${showTaxRate ? 'col-start-3' : 'col-start-2'} pr-4`}>
                                <div className="font-bold text-xs text-gray-600">Subtotal</div>
                                <Currency
                                    value={values.creditSubtotal}
                                    convertToHighestDenomination={false}
                                    className="text-sm text-gray-600"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {showTaxRate && values.debitTaxTotal !== undefined && values.creditTaxTotal !== undefined && (
                <div className="grid grid-cols-[25px_90%_5%] gap-4">
                    <div className={`flex flex-col ${showTaxRate ? 'lg:flex-row' : 'md:flex-row'} w-full col-start-2 ml-4`}>
                        <div
                            className={`grid gap-2 ${showTaxRate ? 'lg:gap-4' : 'md:gap-4'} w-full items-center grid-cols-[1.3fr_1.5fr]`}
                        />
                        <div
                            className={`grid gap-2 w-full pt-1 items-center ${
                                showTaxRate ? 'grid-cols-3 lg:gap-4' : 'grid-cols-2 md:gap-4'
                            }`}
                        >
                            <div className={`flex flex-col items-end ${showTaxRate ? 'col-start-2' : 'col-start-1'} pr-3`}>
                                <div className="font-bold text-xs text-gray-600">Taxes</div>
                                <Currency
                                    value={values.debitTaxTotal}
                                    convertToHighestDenomination={false}
                                    className="text-sm text-gray-600"
                                />
                            </div>
                            <div className={`flex flex-col items-end ${showTaxRate ? 'col-start-3' : 'col-start-2'} pr-4`}>
                                <div className="font-bold text-xs text-gray-600">Taxes</div>
                                <Currency
                                    value={values.creditTaxTotal}
                                    convertToHighestDenomination={false}
                                    className="text-sm text-gray-600"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {values.valueOutBy ? (
                <div className="grid grid-cols-[25px_90%_5%] gap-4 pt-4 text-red-600 text-xs">
                    <div className="col-start-2 justify-end flex gap-2">
                        <p>Total is out by: </p>
                        <p className="font-medium">
                            {Math.abs(values.valueOutBy)} {values.valueOutBy > 0 ? 'Dr' : 'Cr'}
                        </p>
                    </div>
                </div>
            ) : (
                <></>
            )}
        </>
    );
}

export default JournalTotals;
